import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { initAnalytics } from '../firebase/config';

// Cerez onay bandi.
//
// KVKK acisindan zorunlu: olcumleme (Firebase Analytics) cerezleri
// kullanicinin acik onayi olmadan calistirilamaz. Bu bilesen onay alinana
// kadar Analytics'i baslatmaz; reddedilirse hic baslatilmaz.
//
// Tercih localStorage'da saklanir, her ziyarette tekrar sorulmaz.

const STORAGE_KEY = 'cookie_consent';

const Banner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: #ffffff;
  border-top: 1px solid #e2e2e2;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.08);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 14px 16px;
    gap: 12px;
    flex-direction: column;
    align-items: stretch;
  }
`;

const Text = styled.p`
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.6;
  color: #444;
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    line-height: 1.5;
  }

  a {
    color: #1a1a1a;
    text-decoration: underline;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;

    button {
      flex: 1;
      min-width: 0;
      padding: 11px 8px;
      font-size: 0.72rem;
      letter-spacing: 0.6px;
    }
  }
`;

const Button = styled.button<{ $primary?: boolean }>`
  padding: 11px 22px;
  border-radius: 2px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.25s ease;

  background: ${props => (props.$primary ? '#1a1a1a' : 'white')};
  color: ${props => (props.$primary ? 'white' : '#1a1a1a')};
  border: 1px solid #1a1a1a;

  &:hover {
    background: ${props => (props.$primary ? '#000' : '#f4f4f4')};
  }
`;

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored: string | null = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch {
      // Gizli sekme veya cerezleri engelleyen tarayici: bandi goster,
      // secim saklanamaz ama olcumleme de baslamaz.
    }

    if (stored === 'accepted') {
      initAnalytics();
    } else if (stored !== 'rejected') {
      setVisible(true);
    }
  }, []);

  const decide = (choice: 'accepted' | 'rejected') => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      // saklanamadiysa da secime saygi gosteririz
    }

    if (choice === 'accepted') {
      initAnalytics();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Banner role="dialog" aria-label="Çerez tercihi">
      <Text>
        Sitemizde deneyiminizi geliştirmek için zorunlu çerezler ve onayınıza bağlı
        ölçümleme çerezleri kullanıyoruz. Ölçümleme çerezleri yalnızca kabul
        etmeniz hâlinde çalışır. Ayrıntılar için{' '}
        <Link to="/gizlilik">Gizlilik Politikası</Link> sayfamızı inceleyebilirsiniz.
      </Text>
      <Actions>
        <Button onClick={() => decide('rejected')}>Sadece Zorunlu</Button>
        <Button $primary onClick={() => decide('accepted')}>Kabul Et</Button>
      </Actions>
    </Banner>
  );
};

export default CookieConsent;
